import './banner.component.scss'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper'


new Swiper('.header-banner', {
	modules: [Navigation, Autoplay, EffectFade],
	spaceBetween: 15,
	autoHeight: true,
	navigation: {
		prevEl: '.header-banner-prev',
		nextEl: '.header-banner-next',
	},
	autoplay: {
		delay: 7000,
		pauseOnMouseEnter: false,
		disableOnInteraction: false,
	},
	crossFade: true,
	effect: 'fade',
	loop: true,
})
